import styled from 'styled-components';

const Background = styled.rect``;

export default Background;
